import LocationOnIcon from '@mui/icons-material/LocationOn'
import { Box, Typography } from '@mui/material'

import CopyTextField from '../CopyTextField/CopyTextField.component'
import Modal from '../Modal/Modal.component'

import styles from './LockerDetailsModal.styles'
import { LockerDetailsModalProps } from './LockerDetailsModal.types'

const LockerDetailsModal = ({ open, onClose, lockerDetails }: LockerDetailsModalProps) => {
  const isPickupReady = lockerDetails.orderStatus === 'pickup_pending'

  const handleOpenMap = () => {
    const fullAddress = `${lockerDetails.lockerBank.address}, ${lockerDetails.lockerBank.cityName}, ${lockerDetails.lockerBank.countryName}`
    const mapsUrl = `https://maps.google.com/?q=${encodeURIComponent(fullAddress)}`
    window.open(mapsUrl, '_blank')
  }

  const formatLocationTooltip = () => {
    return (
      <Box sx={{ textAlign: 'left', whiteSpace: 'pre-line' }}>
        <Typography variant="body2" sx={{ fontWeight: 'bold', mb: 0.5 }}>
          {lockerDetails.lockerBank.name}
        </Typography>

        <Typography variant="body2">{lockerDetails.lockerBank.address}</Typography>

        <Typography variant="body2">
          {lockerDetails.lockerBank.cityName}, {lockerDetails.lockerBank.countryName}
        </Typography>

        {lockerDetails.lockerBank.locationNotes && (
          <Typography variant="body2" sx={{ mt: 0.5, fontStyle: 'italic' }}>
            {lockerDetails.lockerBank.locationNotes}
          </Typography>
        )}
      </Box>
    )
  }

  return (
    <Modal
      open={open}
      onClose={onClose}
      title="Locker Details"
      primaryButton={{
        label: 'Get Directions',
        onClick: handleOpenMap,
        startIcon: <LocationOnIcon />,
        tooltipText: formatLocationTooltip()
      }}
      secondaryButton={{
        label: 'Dismiss',
        onClick: onClose
      }}
      body={
        <Box sx={styles.modalContent}>
          {/* Dropoff Code - Only for travelers */}
          {lockerDetails.dropoffCode && (
            <Box sx={styles.section}>
              <Typography sx={styles.sectionTitle}>Dropoff Code</Typography>
              <CopyTextField
                value={lockerDetails.dropoffCode}
                buttonText="Copy Code"
                copiedButtonText="Copied"
                containerSx={styles.purpleCodeContainer}
                textFieldSx={styles.purpleCodeText}
                buttonFullWidth={false}
              />
            </Box>
          )}

          {/* Pickup Code - Only for shoppers when pickup_pending */}
          {lockerDetails.pickupCode && isPickupReady && (
            <Box sx={styles.section}>
              <Typography sx={styles.sectionTitle}>Pickup Code</Typography>
              <CopyTextField
                value={lockerDetails.pickupCode}
                buttonText="Copy Code"
                copiedButtonText="Copied"
                containerSx={styles.purpleCodeContainer}
                textFieldSx={styles.purpleCodeText}
                buttonFullWidth={false}
              />
            </Box>
          )}

          {/* Door Assignments */}
          <Box sx={styles.section}>
            <Typography sx={styles.sectionTitle}>Assigned Lockers</Typography>

            <Box sx={styles.doorAssignmentsContainer}>
              {lockerDetails.doorAssignments.map((door, index) => (
                <Box key={index} sx={styles.doorAssignment}>
                  <Box sx={styles.infoRow}>
                    <Typography sx={styles.infoLabel}>Door</Typography>
                    <Typography sx={styles.infoValue}>{door.doorId}</Typography>
                  </Box>

                  <Box sx={styles.infoRow}>
                    <Typography sx={styles.infoLabel}>Size</Typography>
                    <Typography sx={styles.infoValue}>{door.sizeId}</Typography>
                  </Box>
                </Box>
              ))}
            </Box>
          </Box>
        </Box>
      }
    />
  )
}

export default LockerDetailsModal
